<template>
<v-card
id="frm-login"
elevation="0"

                        class="form-card"  
                        >
                        <v-card-title>
                            <v-img
                            v-if="showLogo"
                    lazy-src="@/img/easyplanner-logo.png"
                    src="@/img/easyplanner-logo.png"
                    height="110px"  
                    contain
                    color="transparent"
                    alt="EASYPLANNER"
                  ></v-img>
                        </v-card-title>
                        <v-card-text>  
    <v-col cols="12" style="margin-bottom: 0.5vh">
      <v-text-field
        ref="input"
        label="Username"
        name="username"
        v-model="username"
        v-on:keyup.enter="subitOwnerLogin"
        type="text"
        filled
      ></v-text-field>
    </v-col>

    <v-col cols="12" style="margin-bottom: 1vh">
      <v-text-field
        ref="input"
        v-on:keyup.enter="subitOwnerLogin"
        v-model="password"
        label="Password"
        name="password"
        filled
        :type="passwordFieldType"
        :append-icon="passwordIcon"
        @click:append="showPassword()"
      ></v-text-field>
    </v-col>

    <v-col cols="12">
      <v-row>
        <v-col cols="6">
          <v-btn large class="btnLoginOwner" block to="/Signup">
            Registrati
          </v-btn>
        </v-col>
        <v-col cols="6">
          <v-btn large class="btnLogin" block @click="subitOwnerLogin">
            Accedi
            <template v-slot:loader>
              <span>Logging in...</span>
            </template>
          </v-btn>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="2">
          <v-btn text @click="forgotPassword()" color="primary">
            Forgot Password?
          </v-btn>
        </v-col>
      </v-row>

      <!-- <v-dialog v-model="dialog" width="2000">
                <Signup></Signup>
              </v-dialog> -->
    </v-col>
    <v-dialog v-model="dialog" width="1000">
      <v-card>
        <FrmRecoverPassword
          v-on:close-dialog="closeDialog"
        ></FrmRecoverPassword>
      </v-card>
    </v-dialog> 
                        </v-card-text>
</v-card>
</template> 


<style lang="scss">
.loginCard {
  padding: 60px !important;
}
#frm-login{
  background:transparent;
}
.btnLoginOwner {
  background-color: #cf1818 !important;
  color: #ffffff !important;
}
.btnLogin {
    background-color: #000000 !important;
    color: #ffffff !important;
}
</style>


<script>
import EasyPlanClient from "../../utils/EasyPlanClient";
import SessionHelper from "../../utils/SessionHelper";
import FrmRecoverPassword from "../../components/FrmRecoverPassword/FrmRecoverPassword.vue";
export default {
  components: { FrmRecoverPassword },
  props:{
showLogo:{default:true,type:Boolean}
  },
  data() {
    return {
      loader: "",
      dialog: false,
      username: "",
      password: "",
      passwordIcon: "mdi-lock",
      passwordFieldType: "password",
    };
  },
  methods: {
    closeDialog: function () {
      this.dialog = false;
    },

    subitOwnerLogin() {
      this.loader = "loading";
      EasyPlanClient.User.LoginOwner(this.username, this.password)
        .then((res) => {
          console.debug("risposta user login:");
          console.debug(res);
          localStorage.userToken = res.data.data;
          console.debug("Imposto JWT:");
           
          EasyPlanClient.SetJWT(res.data.data);
          console.debug("Redirect to dashboard:");
          this.$router.push({
            name: "owner-dashboard",
          });

          this.loader = "";
        })
        .catch((error) => {
          this.loader = "";
          let err = error.response.data.errorCode;
          if (err == "USER_IS_NOT_VERIFIED") {
            //redirect to account confirmation
            localStorage.userToken = null;
            EasyPlanClient.SetJWT(error.response.data.data); //contiene nuovo token
            this.$router.push({
              name: "signup",
              query: {
                action: "account-verification",
                jwt: error.response.data.data,
              },
            });
          }
          if (err == "OWNER_HAS_NOT_COMPANY") {
            //redirect company creation
            localStorage.userToken = null;
            EasyPlanClient.SetJWT(error.response.data.data); //contiene nuovo token
            this.$router.push({
              name: "signup",
              query: {
                action: "company-creation",
                jwt: error.response.data.data,
              },
            });
          } else {
            this.error = EasyPlanClient.GetErrorDescription(
              error.response.data.errorCode
            );
            console.error(
              "si è verificato un errore (" +
                error.response.data.errorCode +
                ")" +
                this.error
            );
            console.error(error);
          }
        });
    },
    showPassword() {
      this.passwordIcon =
        this.passwordIcon === "mdi-lock" ? "mdi-lock-open-variant" : "mdi-lock";
      this.passwordFieldType =
        this.passwordFieldType === "password" ? "text" : "password";
    },
    forgotPassword() {
      this.dialog = true;
    },
  },
  created: function () {
    console.debug(localStorage.userToken);
    if (
      localStorage.userToken != undefined &&
      localStorage.userToken != "null"
    ) {
      console.debug("redirecting");
      EasyPlanClient.SetJWT(localStorage.userToken);
      this.$router.push({
        name: "owner-dashboard",
      });
    }
  },
  computed: {
    ShowSnackbar: {
      get() {
        return this.error.length > 0;
      },
      set(value) {
        if (!value) this.error = "";
      },
    },
    loading: {
      get() {
        return this.loader.length > 0;
      },
    },
  },
};
</script>